
<template>
	<v-container width="100%" ml-auto mr-auto pl-3 pr-0 pb-3 style="padding-top: 150px;">
		<v-flex mb-4>
			<v-btn to="/SearchType1">Вернуться к фильтрам</v-btn>
		</v-flex>

		<v-layout row wrap>
			<CardTemplate :data="parseData"/>
		</v-layout>
	</v-container>
</template>

<script>
import axios from 'axios';
import CardTemplate from '../components/CardTemplate.vue';

export default {
	name: 'PersoneCard',

	data () {
		return {
			id: this.$router.currentRoute.params.id,
			lng: this.$store.getters.ACTIVE_LANGUAGE,
			pageData: {
				"id": 19981,
				"people": [],
				"company": [],
				"date": "2019-05-27",
				"translate": {
					"ru": {
						"name": "Наименование",
						"list_people": "Учередители",
						"list_company": "Связанные компании"
					},
					"kaz": {
						"name": "Наименование",
						"list_people": "Учередители",
						"list_company": "Связанные компании"
					}
				},
				"bin": "124124124124",
			}
		}
	},

	components: {
		CardTemplate
	},

	created () {
	},

  	computed: {
		parseData () {
			let parsedData = {};
			
			parsedData.list = [
				{
					name: 'ИД',
					value: this.pageData.id
				},
				{
					name: 'Дата создания',
					value: this.pageData.date
				},
				{
					name: 'БИН',
					value: this.pageData.bin
				}
			];

			parsedData.name = this.pageData.translate[this.lng].name;

			return parsedData;
		}
	},

	methods: {
	}
}
</script>

<style lang="scss">
</style>
